import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { toastr } from "react-redux-toastr";

import { closeModal } from "../../../../store/modules/modal/actions";
import { getUser } from "../../../../store/modules/session/selectors";

import { FormActionTypes, ValueTypes } from "../formSettings";

import { importFile } from "../../../../utils/importFile";

type DownloadFile = ((file: string) => Promise<File>) | ((file: File) => Promise<File>);

export const useSubmitCallback = (user: ReturnType<typeof getUser>, downloadFile: DownloadFile) => {
  const dispatch = useDispatch();

  return useCallback((values: ValueTypes, actions: FormActionTypes) => {
    const { folderId, files } = values;

    if (user) {
      const promises = files.map(fileValue => (
        downloadFile(fileValue)
          .then((file) => importFile(user, folderId, file))
      ));

      Promise.all(promises)
        .then(() => {
          dispatch(closeModal());
        })
        .catch(({ message }: Error) => {
          toastr.error("Firebase", message);
          actions.setSubmitting(false);
          console.error(message);
        });
    } else {
      actions.setSubmitting(false);
    }
  }, [user, downloadFile, dispatch]);
};
